/* ============================================================
   BH HEADER v10.6 — Restored Original Scroll + Mobile Fixes
   ============================================================ */
(function () {
  'use strict';

  if (window.__bhV10) {
    try { window.__bhV10.destroy(); } catch (e) {}
  }

  var scrollLockCount = 0;
  function lockBody() { scrollLockCount++; document.body.style.overflow = 'hidden'; }
  function unlockBody() { scrollLockCount = Math.max(0, scrollLockCount - 1); if (scrollLockCount === 0) document.body.style.overflow = ''; }

  /* ══════════════════════════════════════════════════
     BH CART DRAWER
     ══════════════════════════════════════════════════ */

  function ensureCartDrawerDOM() {
    if (document.getElementById('bh-cart-drawer')) return;

    var style = document.createElement('style');
    style.id = 'bh-cd-styles';
    style.textContent = [
      '.bh-cd{position:fixed;top:var(--bh-under-header,56px);left:0;right:0;bottom:0;z-index:990;visibility:hidden;pointer-events:none}',
      '.bh-cd.is-open{visibility:visible;pointer-events:auto}',
      '.bh-cd__overlay{position:absolute;inset:0;background:rgba(0,0,0,.4);opacity:0;transition:opacity .3s}',
      '.bh-cd.is-open .bh-cd__overlay{opacity:1}',
      '.bh-cd__panel{position:absolute;top:0;right:0;bottom:0;width:min(420px,92vw);background:#fff;display:flex;flex-direction:column;box-shadow:-4px 0 24px rgba(0,0,0,.12);transform:translateX(100%);transition:transform .32s cubic-bezier(.32,.72,0,1)}',
      '.bh-cd.is-open .bh-cd__panel{transform:translateX(0)}',
      '.bh-cd__header{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #eee;flex-shrink:0}',
      '.bh-cd__title{font-size:15px;font-weight:600;text-transform:uppercase;letter-spacing:.5px}',
      '.bh-cd__close{display:flex;align-items:center;justify-content:center;width:36px;height:36px;border:none;background:none;cursor:pointer;color:#333;border-radius:50%;transition:background .15s}',
      '.bh-cd__close:hover{background:#f0f0f0}',
      '.bh-cd__body{flex:1;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}',
      '.bh-cd__footer{flex-shrink:0;background:#fff}',
      '.bh-cd__init-load{display:flex;align-items:center;justify-content:center;padding:48px 20px}',
      '.bh-cd__init-spin{width:24px;height:24px;border:2px solid #eee;border-top-color:#333;border-radius:50%;animation:bh-cd-spin .6s linear infinite}',
      '@keyframes bh-cd-spin{to{transform:rotate(360deg)}}',
      '.bh-cd__item--updating{opacity:.5;pointer-events:none}'
    ].join('\n');
    document.head.appendChild(style);

    var wrapper = document.createElement('div');
    wrapper.id = 'bh-cart-drawer';
    wrapper.className = 'bh-cd';
    wrapper.innerHTML = [
      '<div class="bh-cd__overlay" data-bh-cd-close></div>',
      '<div class="bh-cd__panel">',
        '<div class="bh-cd__header">',
          '<span class="bh-cd__title">Sepet (<span id="bh-cd-count">0</span>)</span>',
          '<button type="button" class="bh-cd__close" aria-label="Kapat" data-bh-cd-close>',
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
          '</button>',
        '</div>',
        '<div class="bh-cd__body" id="bh-cd-body">',
          '<div class="bh-cd__init-load"><div class="bh-cd__init-spin"></div></div>',
        '</div>',
        '<div class="bh-cd__footer" id="bh-cd-footer" style="display:none"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(wrapper);
  }

  function fetchAndUpdateBubble() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var b = document.querySelector('[data-bh-cart-count]');
        if (b) b.textContent = cart.item_count > 0 ? cart.item_count : '';
        var cnt = document.getElementById('bh-cd-count');
        if (cnt) cnt.textContent = cart.item_count;
        return cart;
      })
      .catch(function (e) { console.warn('[BH Cart]', e); return null; });
  }

  var cartDrawerIsOpen = false;

  function openBhCartDrawer() {
    ensureCartDrawerDOM();
    var el = document.getElementById('bh-cart-drawer');
    if (!el) return false;

    if (!cartDrawerIsOpen) {
      var body = document.getElementById('bh-cd-body');
      if (body && !body.querySelector('.bc__items')) {
        body.innerHTML = '<div class="bh-cd__init-load"><div class="bh-cd__init-spin"></div></div>';
      }
      var ft = document.getElementById('bh-cd-footer');
      if (ft && !ft.innerHTML.trim()) ft.style.display = 'none';

      cartDrawerIsOpen = true;
      el.classList.add('is-open');
      lockBody();
    }

    if (typeof window.__bhCartFetch === 'function') {
      window.__bhCartFetch();
    }

    return true;
  }

  function closeBhCartDrawer() {
    var el = document.getElementById('bh-cart-drawer');
    if (!el || !cartDrawerIsOpen) return;
    cartDrawerIsOpen = false;
    el.classList.remove('is-open');
    unlockBody();
  }

  function initCartDrawerEvents() {
    if (window.__bhCdEventsInit) return;
    window.__bhCdEventsInit = true;
    document.addEventListener('click', function (e) {
      if (!cartDrawerIsOpen) return;
      if (e.target.closest('[data-bh-cd-close]')) { closeBhCartDrawer(); return; }
    });
  }

  window.__bhOpenCartDrawer = openBhCartDrawer;
  window.__bhRefreshAndOpenCartDrawer = function () { openBhCartDrawer(); };

  /* ══════════════════════════════════════════════════
     MAIN HEADER INIT
     ══════════════════════════════════════════════════ */

  function bhInit() {
    var header = document.getElementById('bh-header');
    if (!header) return null;
    document.body.classList.add('bh-header-active');

    var stickyMode = header.dataset.sticky || 'none';
    var shouldShrink = header.dataset.shrink === 'true';
    var threshold = parseInt(header.dataset.threshold, 10) || 80;

    var section = header.closest('.bh-header-section') || header.closest('.shopify-section');
    var bar = header.querySelector('.bh-bar');
    var spacer = ensureSpacer(section);

    var scrollMediaQuery = window.matchMedia('(min-width: 990px)');
    var isFixed = false, isShrunk = false, lastY = 0, cachedBarH = 0;
    var listeners = [];
    var scrollTarget = null;
    var scrollTicking = false;
    var resizeTimer = null;

    function on(el, evt, fn, opts) { el.addEventListener(evt, fn, opts || false); listeners.push([el, evt, fn, opts || false]); }

    function ensureSpacer(sectionEl) {
      if (!sectionEl) return null;
      var s = sectionEl.querySelector('#bh-header-spacer');
      if (!s) { s = document.createElement('div'); s.id = 'bh-header-spacer'; sectionEl.insertBefore(s, sectionEl.firstChild); }
      return s;
    }

    function getPageWrapper() {
      return document.querySelector('.page-wrapper');
    }

    function getScrollContainer() {
      if (scrollMediaQuery.matches) {
        return getPageWrapper() || document.scrollingElement || document.documentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    function getScrollEventTarget() {
      if (scrollMediaQuery.matches) {
        return getPageWrapper() || document;
      }
      return document;
    }

    function getScrollTop() {
      var container = getScrollContainer();
      return container && typeof container.scrollTop === 'number' ? container.scrollTop : (window.scrollY || 0);
    }

    /* --- RESTORED ORIGINAL SCROLL LOGIC --- */
    function readBarHeight() { cachedBarH = bar ? bar.offsetHeight : header.offsetHeight; return cachedBarH; }

    function getAnnouncementBottom() {
      var ann = section ? section.previousElementSibling : null;
      if (!ann) return 0;
      return Math.max(0, ann.getBoundingClientRect().bottom);
    }

    function writeVars(barH, annBottom) {
      var underHeader = isFixed ? barH + annBottom : Math.max(barH, header.getBoundingClientRect().bottom);
      var ds = document.documentElement.style;
      ds.setProperty('--bh-bar-h-current', barH + 'px');
      ds.setProperty('--bh-under-header', underHeader + 'px');
      ds.setProperty('--bh-header-h', barH + 'px');
      document.body.style.setProperty('--header-height', '0px');
      document.body.style.setProperty('--header-group-height', '0px');
    }

    function setSpacerHeight(px) { if (spacer) spacer.style.height = (px || 0) + 'px'; }

    function handleSticky() {
      var y = getScrollTop();
      var annBottom = getAnnouncementBottom();
      var shouldAlwaysFix = stickyMode === 'always';
      var shouldFix = stickyMode !== 'none' && y > 0;
      var shouldBeHidden = stickyMode === 'scroll-up' && y > lastY && y > threshold;
      var shouldBeShrunk = shouldShrink && y > threshold;

      if (shouldBeShrunk !== isShrunk) {
        isShrunk = shouldBeShrunk;
        header.classList.toggle('is-shrunk', isShrunk);
      }

      var barH = readBarHeight();

      if (shouldAlwaysFix || shouldFix) {
        if (!isFixed) { isFixed = true; header.classList.add('is-fixed'); }
        header.style.setProperty('--bh-fixed-top', annBottom + 'px');
      } else if (isFixed) {
        isFixed = false;
        header.classList.remove('is-fixed', 'is-hidden');
        header.style.removeProperty('--bh-fixed-top');
      }

      if (!isFixed) {
        setSpacerHeight(0);
      } else if (shouldAlwaysFix) {
        header.classList.remove('is-hidden');
        setSpacerHeight(barH);
      } else if (stickyMode === 'scroll-up') {
        header.classList.toggle('is-hidden', shouldBeHidden);
        setSpacerHeight(shouldBeHidden ? 0 : barH);
      } else {
        setSpacerHeight(barH);
      }

      writeVars(barH, annBottom);
      lastY = y;
    }

    function handleScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () { handleSticky(); scrollTicking = false; });
    }

    function bindScrollTarget() {
      var nextScrollTarget = getScrollEventTarget();
      if (scrollTarget === nextScrollTarget) return;
      if (scrollTarget) scrollTarget.removeEventListener('scroll', handleScroll);
      scrollTarget = nextScrollTarget;
      if (scrollTarget) scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
    }

    function handleBreakpointChange() {
      bindScrollTarget();
      lastY = getScrollTop();
      readBarHeight();
      handleSticky();
    }

    on(window, 'resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { readBarHeight(); handleSticky(); }, 100); });
    if (scrollMediaQuery.addEventListener) {
      scrollMediaQuery.addEventListener('change', handleBreakpointChange);
    } else if (scrollMediaQuery.addListener) {
      scrollMediaQuery.addListener(handleBreakpointChange);
    }

    bindScrollTarget();
    lastY = getScrollTop();
    readBarHeight();
    handleSticky();

    /* ══ MEGA MENU ══ */
    var megaTriggers = header.querySelectorAll('[data-mega-trigger]');
    var megaPanels = header.querySelectorAll('[data-mega-panel]');
    var backdrop = document.getElementById('bh-mega-backdrop');
    var activeMega = null, megaCloseTimer = null, megaOpenTimer = null;

    function showBackdrop() { if (backdrop) backdrop.classList.add('is-visible'); }
    function hideBackdrop() { if (backdrop) backdrop.classList.remove('is-visible'); }

    function openMega(id) {
      clearTimeout(megaCloseTimer); clearTimeout(megaOpenTimer);
      if (activeMega && activeMega.id === id) return;
      if (activeMega) { activeMega.classList.remove('is-open'); var p = header.querySelector('[data-mega-trigger="' + activeMega.id + '"]'); if (p) p.setAttribute('aria-expanded', 'false'); }
      var panel = document.getElementById(id); if (!panel) return;
      activeMega = panel; panel.classList.add('is-open'); showBackdrop();
      var tr = header.querySelector('[data-mega-trigger="' + id + '"]'); if (tr) tr.setAttribute('aria-expanded', 'true');
    }

    function closeMega() {
      clearTimeout(megaCloseTimer); clearTimeout(megaOpenTimer);
      if (!activeMega) return;
      activeMega.classList.remove('is-open');
      var tr = header.querySelector('[data-mega-trigger="' + activeMega.id + '"]'); if (tr) tr.setAttribute('aria-expanded', 'false');
      activeMega = null; hideBackdrop();
    }

    function scheduleClose() { clearTimeout(megaCloseTimer); megaCloseTimer = setTimeout(closeMega, 300); }
    function cancelClose() { clearTimeout(megaCloseTimer); }

    megaTriggers.forEach(function (t) {
      var tid = t.getAttribute('data-mega-trigger');
      on(t, 'pointerenter', function () { cancelClose(); clearTimeout(megaOpenTimer); if (activeMega) openMega(tid); else megaOpenTimer = setTimeout(function () { openMega(tid); }, 60); });
      on(t, 'pointerleave', function () { clearTimeout(megaOpenTimer); scheduleClose(); });
    });
    megaPanels.forEach(function (p) { on(p, 'pointerenter', cancelClose); on(p, 'pointerleave', scheduleClose); });
    if (backdrop) on(backdrop, 'click', function () { cancelClose(); closeMega(); });

    function activateTab(c, idx) {
      c.querySelectorAll('.bh-mega__tab').forEach(function (t, i) { t.classList.toggle('is-active', i === idx); t.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      c.querySelectorAll('.bh-mega__linkpanel').forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
    }
    on(header, 'pointerenter', function (e) { var t = e.target.closest('.bh-mega__tab'); if (t) { var c = t.closest('.bh-mega__panel'); if (c) activateTab(c, parseInt(t.dataset.tabIndex, 10)); } }, true);
    on(header, 'click', function (e) { var t = e.target.closest('.bh-mega__tab'); if (t) { var c = t.closest('.bh-mega__panel'); if (c) activateTab(c, parseInt(t.dataset.tabIndex, 10)); } });

    /* ══ ACCOUNT DROPDOWN ══ */
    var accountEl = document.querySelector('[data-account-dropdown]');
    var accountBtn = document.querySelector('[data-account-trigger]');
    var accountLeaveTimer = null;
    function openAccount() { if (accountEl) { accountEl.classList.add('is-open'); if (accountBtn) accountBtn.setAttribute('aria-expanded', 'true'); } }
    function closeAccount() { if (accountEl) { accountEl.classList.remove('is-open'); if (accountBtn) accountBtn.setAttribute('aria-expanded', 'false'); } }
    if (accountEl) {
      on(accountEl, 'pointerenter', function (e) { if (e.pointerType === 'touch') return; clearTimeout(accountLeaveTimer); openAccount(); });
      on(accountEl, 'pointerleave', function (e) { if (e.pointerType === 'touch') return; accountLeaveTimer = setTimeout(closeAccount, 200); });
      
      if (accountBtn) on(accountBtn, 'click', function (e) { 
        e.preventDefault(); 
        e.stopPropagation(); 
        accountEl.classList.contains('is-open') ? closeAccount() : openAccount(); 
      });
      
      on(document, 'click', function(e) { 
        if (accountEl.classList.contains('is-open') && !e.target.closest('[data-account-dropdown]')) { 
          closeAccount(); 
        } 
      });
    }

    /* ══ SEARCH OVERLAY ══ */
    var searchOverlay = document.getElementById('bh-search-overlay');
    var searchInput = searchOverlay ? searchOverlay.querySelector('.bh-search__input') : null;
    var searchResultsContainer = searchOverlay ? searchOverlay.querySelector('.bh-search__result-list') : null;
    var searchNoResults = searchOverlay ? searchOverlay.querySelector('.bh-search__no-results') : null;
    var searchDebounce = null, searchIsOpen = false;

    function openSearch() {
      if (!searchOverlay || searchIsOpen) return;
      readBarHeight(); handleSticky();
      searchIsOpen = true;
      searchOverlay.classList.add('is-open'); searchOverlay.classList.remove('has-results', 'is-loading');
      lockBody(); closeMega(); closeAccount(); closeBhCartDrawer();
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 120);
    }
    function closeSearch() {
      if (!searchOverlay || !searchIsOpen) return;
      searchIsOpen = false; searchOverlay.classList.remove('is-open', 'has-results', 'is-loading');
      if (searchInput) searchInput.value = '';
      if (searchResultsContainer) searchResultsContainer.innerHTML = '';
      if (searchNoResults) searchNoResults.style.display = 'none';
      unlockBody();
    }

    document.querySelectorAll('[data-bh-search-trigger]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openSearch(); }); });
    document.querySelectorAll('[data-search-close]').forEach(function (b) { on(b, 'click', closeSearch); });
    if (searchOverlay) { var bg = searchOverlay.querySelector('.bh-search-overlay__bg'); if (bg) on(bg, 'click', closeSearch); }

    function formatMoney(amount) {
      if (amount === null || amount === undefined || amount === '') return '';
      var value = Number(amount); if (!Number.isFinite(value)) return String(amount);
      return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function fetchSearch(query) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide&resources[options][fields]=title,tag,product_type,vendor,variants.sku,variants.title')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!searchOverlay) return;
          searchOverlay.classList.remove('is-loading');
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { searchOverlay.classList.add('has-results'); if (searchResultsContainer) searchResultsContainer.innerHTML = ''; if (searchNoResults) searchNoResults.style.display = 'block'; return; }
          if (searchNoResults) searchNoResults.style.display = 'none';
          searchOverlay.classList.add('has-results');
          var html = '';
          products.forEach(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            html += '<a href="' + escapeHtml(p.url) + '" class="bh-search__result-item">';
            if (img) html += '<img src="' + escapeHtml(img) + '" alt="" class="bh-search__result-img" loading="lazy">';
            html += '<div class="bh-search__result-info"><div class="bh-search__result-title">' + escapeHtml(p.title) + '</div><div class="bh-search__result-price">';
            if (p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price)) html += '<s>' + formatMoney(p.compare_at_price) + '</s> ';
            html += formatMoney(p.price) + '</div></div></a>';
          });
          if (searchResultsContainer) searchResultsContainer.innerHTML = html;
        })
        .catch(function () { if (searchOverlay) searchOverlay.classList.remove('is-loading'); });
    }

    if (searchInput && searchResultsContainer) {
      on(searchInput, 'input', function () {
        var q = searchInput.value.trim(); clearTimeout(searchDebounce);
        if (q.length < 2) { searchOverlay.classList.remove('has-results', 'is-loading'); searchResultsContainer.innerHTML = ''; if (searchNoResults) searchNoResults.style.display = 'none'; return; }
        searchOverlay.classList.add('is-loading');
        searchDebounce = setTimeout(function () { fetchSearch(q); }, 260);
      });
      on(searchInput, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var q = searchInput.value.trim(); if (q) window.location.href = '/search?q=' + encodeURIComponent(q); } });
    }

    /* ══ CART BUTTON ══ */
    var cartBtn = document.querySelector('[data-bh-cart-trigger]');
    if (cartBtn) {
      on(cartBtn, 'click', function (e) {
        e.preventDefault(); e.stopPropagation();
        closeMega(); closeSearch(); closeAccount();
        if (!openBhCartDrawer()) window.location.href = '/cart';
      });
    }

    /* Cart bubble initial */
    fetchAndUpdateBubble();

    /* ══ MOBILE DRAWER ══ */
    var drawer = document.getElementById('bh-mobile-drawer');
    var drawerTemplate = document.getElementById('bh-mobile-drawer-template');
    var hamburgerBtn = document.querySelector('[data-mobile-toggle]');
    var drawerIsOpen = false;
    var mobileDrawerEventsInitialized = false;
    var drawerReturnFocus = null;
    var drawerBackTimer = null;

    function getDrawerFocusables() {
      if (!drawer) return hamburgerBtn ? [hamburgerBtn] : [];

      var scope = drawer.querySelector('.bh-mobile-drawer__level--main');
      if (drawer.classList.contains('slide-active')) {
        scope = drawer.querySelector('.bh-mobile-drawer__level--sub.is-open') || scope;
      }

      var focusables = scope ? Array.prototype.slice.call(scope.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')) : [];
      if (hamburgerBtn) focusables.unshift(hamburgerBtn);
      return focusables;
    }

    function focusDrawerStart() {
      var focusables = getDrawerFocusables();
      var target = focusables.length > 1 ? focusables[1] : focusables[0];
      if (target) target.focus({ preventScroll: true });
    }

    function trapDrawerFocus(e) {
      if (!drawerIsOpen || e.key !== 'Tab') return;
      var focusables = getDrawerFocusables();
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      } else if (focusables.indexOf(active) === -1) {
        e.preventDefault();
        first.focus();
      }
    }

    function initMobileDrawer(drawerEl) {
      if (!drawerEl || mobileDrawerEventsInitialized) return;
      mobileDrawerEventsInitialized = true;

      var dOv = drawerEl.querySelector('.bh-mobile-drawer__overlay');
      if (dOv) on(dOv, 'click', closeDrawer);

      drawerEl.querySelectorAll('.bh-m-accordion__trigger').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', trigger.closest('.bh-m-accordion').classList.contains('is-open') ? 'true' : 'false');
      });

      on(drawerEl, 'click', function (e) {
        var ob = e.target.closest('[data-open-sub]');
        if (ob) {
          var sub = document.getElementById(ob.getAttribute('data-open-sub'));
          if (sub) {
            var main = drawerEl.querySelector('.bh-mobile-drawer__level--main');
            clearTimeout(drawerBackTimer);
            drawerEl.classList.add('slide-active');
            sub.classList.add('is-open');
            sub.setAttribute('aria-hidden', 'false');
            ob.setAttribute('aria-expanded', 'true');
            if (main) main.setAttribute('aria-hidden', 'true');
            var back = sub.querySelector('[data-back-main]');
            if (back) setTimeout(function () {
              if (drawerIsOpen && sub.classList.contains('is-open')) back.focus({ preventScroll: true });
            }, 0);
          }
          return;
        }

        var bb = e.target.closest('[data-back-main]');
        if (bb) {
          var activeSub = bb.closest('.bh-mobile-drawer__level--sub');
          var opener = activeSub ? drawerEl.querySelector('[data-open-sub="' + activeSub.id + '"]') : null;
          var mainLevel = drawerEl.querySelector('.bh-mobile-drawer__level--main');
          drawerEl.classList.remove('slide-active');
          if (mainLevel) mainLevel.setAttribute('aria-hidden', 'false');
          if (activeSub) activeSub.setAttribute('aria-hidden', 'true');
          if (opener) opener.setAttribute('aria-expanded', 'false');
          clearTimeout(drawerBackTimer);
          drawerBackTimer = setTimeout(function () {
            drawerEl.querySelectorAll('.bh-mobile-drawer__level--sub.is-open').forEach(function (panel) { panel.classList.remove('is-open'); });
            if (opener) opener.focus({ preventScroll: true });
          }, 320);
          return;
        }

        var at = e.target.closest('.bh-m-accordion__trigger');
        if (at) {
          var ac = at.closest('.bh-m-accordion');
          if (ac) {
            ac.classList.toggle('is-open');
            at.setAttribute('aria-expanded', ac.classList.contains('is-open') ? 'true' : 'false');
          }
        }
      });
    }

    function ensureMobileDrawer() {
      if (!drawer) drawer = document.getElementById('bh-mobile-drawer');
      if (!drawer) return null;

      if (drawer.childElementCount === 0) {
        if (!drawerTemplate) drawerTemplate = document.getElementById('bh-mobile-drawer-template');
        if (!drawerTemplate || !drawerTemplate.content) return null;
        drawer.appendChild(drawerTemplate.content.cloneNode(true));
      }

      initMobileDrawer(drawer);
      return drawer;
    }

    function openDrawer() {
      drawer = ensureMobileDrawer();
      if (!drawer || drawerIsOpen) return;
      drawerReturnFocus = document.activeElement;
      drawerIsOpen = true; readBarHeight(); handleSticky();
      drawer.classList.add('is-open'); document.body.classList.add('bh-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockBody();
      if (hamburgerBtn) {
        hamburgerBtn.classList.add('is-active');
        hamburgerBtn.setAttribute('aria-expanded', 'true');
        hamburgerBtn.setAttribute('aria-label', 'Menüyü kapat');
      }
      if (stickyMode !== 'none') { isFixed = true; header.classList.add('is-fixed'); }
      setSpacerHeight(cachedBarH); closeMega(); closeSearch(); closeAccount(); closeBhCartDrawer();
      setTimeout(function () { if (drawerIsOpen) focusDrawerStart(); }, 0);
    }
    function closeDrawer() {
      if (!drawer || !drawerIsOpen) return;
      clearTimeout(drawerBackTimer);
      drawerIsOpen = false; drawer.classList.remove('is-open', 'slide-active');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bh-drawer-open'); unlockBody();
      if (hamburgerBtn) {
        hamburgerBtn.classList.remove('is-active');
        hamburgerBtn.setAttribute('aria-expanded', 'false');
        hamburgerBtn.setAttribute('aria-label', 'Menü');
      }
      var main = drawer.querySelector('.bh-mobile-drawer__level--main');
      if (main) main.setAttribute('aria-hidden', 'false');
      drawer.querySelectorAll('[data-open-sub][aria-expanded="true"]').forEach(function (opener) { opener.setAttribute('aria-expanded', 'false'); });
      drawer.querySelectorAll('.bh-mobile-drawer__level--sub.is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      handleSticky();
      if (drawerReturnFocus && drawerReturnFocus.isConnected) drawerReturnFocus.focus({ preventScroll: true });
      drawerReturnFocus = null;
    }

    if (hamburgerBtn) on(hamburgerBtn, 'click', function () { drawerIsOpen ? closeDrawer() : openDrawer(); });

    /* ── ESC closes everything ── */
    on(document, 'keydown', function (e) {
      trapDrawerFocus(e);
      if (e.key === 'Escape') { closeMega(); closeAccount(); closeSearch(); closeDrawer(); closeBhCartDrawer(); }
    });
    on(document, 'click', function (e) { if (activeMega && !e.target.closest('#bh-header') && !e.target.closest('[data-mega-panel]')) closeMega(); }, true);

    function destroy() {
      if (scrollTarget) {
        scrollTarget.removeEventListener('scroll', handleScroll);
        scrollTarget = null;
      }
      if (scrollMediaQuery.removeEventListener) {
        scrollMediaQuery.removeEventListener('change', handleBreakpointChange);
      } else if (scrollMediaQuery.removeListener) {
        scrollMediaQuery.removeListener(handleBreakpointChange);
      }
      clearTimeout(resizeTimer);
      clearTimeout(drawerBackTimer);
      listeners.forEach(function (a) { try { a[0].removeEventListener(a[1], a[2], a[3]); } catch (e) {} });
      listeners.length = 0;
    }
    return { destroy: destroy };
  }

  initCartDrawerEvents();
  window.__bhV10 = bhInit();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('#bh-header')) { if (window.__bhV10) { try { window.__bhV10.destroy(); } catch (e2) {} } window.__bhV10 = bhInit(); }
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.querySelector('#bh-header')) { var h = document.getElementById('bh-header'); if (h) h.classList.remove('is-hidden'); }
    });
  }
})();
